import React from 'react';
import styled, { css } from 'styled-components';

// Preventing hasErrored and other internal props from being passed to DOM
const FieldWrapper = styled.div.withConfig( {
	shouldForwardProp: ( prop ) =>
		! [ 'hasErrored', 'styles' ].includes( prop ),
} )`
	display: inline-flex;
	flex-direction: column;
	width: 100%;
	& {
		${ ( props ) =>
			props.hasErrored && props.styles.fieldWrapper
				? props.styles.fieldWrapper.errored
				: undefined };
	}

	${ ( props ) =>
		props.styles.fieldWrapper
			? props.styles.fieldWrapper.base
			: undefined };
`;

const InputWrapper = styled.div.withConfig( {
	shouldForwardProp: ( prop ) =>
		! [ 'hasErrored', 'focused', 'styles' ].includes( prop ),
} )`
	align-items: center;
	background-color: white;
	border: 1px solid #bdbdbd;
	box-shadow: inset 0px 1px 2px #e5e5e5;
	border-radius: 0.2em;
	display: flex;
	height: 2.5em;
	padding: 0.4em 0.6em;
	width: 100%; /* Ensure the wrapper takes the full width */

	& {
		${ ( props ) =>
			props.hasErrored &&
			css`
				border-color: #c9444d;
				box-shadow: #c9444d 0px 0px 0px 1px;
				${ ( props ) =>
					props.styles.inputWrapper &&
					props.styles.inputWrapper.errored };
			` };
	}

	& {
		${ ( props ) =>
			props.focused &&
			css`
				border-color: #444bc9;
				box-shadow: #444bc9 0px 0px 0px 1px;
				${ ( props ) =>
					props.styles.inputWrapper &&
					props.styles.inputWrapper.focused };
			` };
	}

	& input {
		border: unset;
		margin: unset;
		padding: unset;
		outline: unset;
		font-size: inherit;
		width: 100%; /* Take full width by default */
		min-width: 11em; /* Default minimum width */
		flex-grow: 1; /* Allow input to grow */

		& {
			${ ( props ) =>
				props.hasErrored && props.styles.input
					? props.styles.input.errored
					: undefined };
		}

		${ ( props ) => props.styles.input && props.styles.input.base };

		&:focus {
			width: 15em; /* Increase width on focus */
			transition: width 0.3s ease;
		}
	}

	& svg {
		margin-right: 0.6em;
		& {
			${ ( props ) => props.styles.cardImage };
		}
	}

	& input#cardNumber {
		width: 10em;
		min-width: 10em;

		&:focus {
			width: 13em;
		}
	}

	& input#expiryDate {
		width: 4em;
		min-width: 4em;

		&:focus {
			width: 5em;
		}
	}

	& input#cvc {
		width: 2.5em;
		min-width: 2.5em;

		&:focus {
			width: 3.5em;
		}
	}

	& input#zip {
		width: 4em;
		min-width: 4em;

		&:focus {
			width: 5em;
		}
	}
	& input#streetaddress {
		width: 8em;
		min-width: 8em;

		&:focus {
			width: 9em;
		}
	}

	${ ( props ) =>
		props.styles.inputWrapper
			? props.styles.inputWrapper.base
			: undefined };
`;

const ErrorText = styled.div.withConfig( {
	shouldForwardProp: ( prop ) =>
		! [ 'hasErrored', 'focused', 'styles' ].includes( prop ),
} )`
	color: #c9444d;
	font-size: 0.75rem;
	margin-top: 0.25rem;

	& {
		${ ( props ) =>
			props.styles.errorText ? props.styles.errorText.base : undefined };
	}
`;

function PaymentInputsWrapper( {
	children,
	error,
	errorTextProps,
	focused,
	inputWrapperProps,
	isTouched,
	styles = {}, // Set default value for styles here
	isInitPay,
	...restProps
} ) {
	const hasErrored = error && ( isTouched || ( ! focused && isInitPay ) );

	return (
		<FieldWrapper
			hasErrored={ hasErrored }
			styles={ styles }
			{ ...restProps }
		>
			<InputWrapper
				focused={ focused }
				hasErrored={ hasErrored }
				styles={ styles }
				{ ...inputWrapperProps }
			>
				{ children }
			</InputWrapper>
			{ hasErrored && (
				<ErrorText styles={ styles } { ...errorTextProps }>
					{ error }
				</ErrorText>
			) }
		</FieldWrapper>
	);
}

export default PaymentInputsWrapper;
